import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvVarsService } from '../env-vars.service';

@Injectable({
  providedIn: 'root',
})
export class ClickupApiService {
  private API_URL = this.environment.getEnvKey('API_URL');
  private namespace = 'ticket';
  private url = `${this.API_URL}/${this.namespace}`;
  constructor(
    private _http: HttpClient,
    private environment: EnvVarsService
  ) {}

  public createTicket(ticketData: {
    title: string;
    reason: string;
    description: string;
    image: string;
  }): Promise<any> {
    return this._http.post(`${this.url}`, ticketData).toPromise();
  }
}
